import "./scss/index.scss";
import "./js/index";

// import "./images/radom24-logo.png";
